import React from 'react'
import Contact from '../../components/Contact/Contact'
import Header from '../../components/Header/Header'
import Hero from '../../components/EnviosServicios/Hero'
// import Marcas from '../../components/Marcas/Marcas'
// import Products from '../../components/Products/Products'
import Footer from '../../components/Footer/Footer'
import MarcasGrid from '../../components/Marcas/MarcasGrid'
import EnviosServicios from '../../components/Hero/EnviosServicios'

const Home = () => {
	return (
		<>
			<Header page='home' />
			<Hero />
			{/* <Products /> */}
			<MarcasGrid />
			<EnviosServicios />
			<Contact />
			<Footer />

			{/* 
			<Servicios />
			<Tendencia />
			<Ideas />
			<FormasPago />
			 */}

		</>
	);
}
 
export default Home;
